// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicators_indicator___D1pR"};